"use client"
import React, {useState} from 'react';
import Header from "../../components/Private/Header";
import {Spinner} from "@heroui/react";
import Star from "../../components/Star";
import LikeDislike from "../../components/Like&Dislike";
import {ReactComponent as Replay} from "../../assets/icons/replay.svg";
import {useQuery} from "@tanstack/react-query";
import {request} from "../../lib/request";
import ModalReplay from "../../components/Private/ModalReplay"
import PaginationApp from "../../components/Pagination";
import {Link} from "react-router";

const CommentAvatar = ({src, alt = ""}) => (
    <div className="rest-comment-avatar" aria-hidden="true">
        <img src={src} alt={alt} />
    </div>
);

const Comments = () => {
    const [page, setPage] = useState(1)
    const {data, isLoading, refetch} = useQuery({
        queryKey: ["comments", "index", page],
        queryFn: async () => await request({
            url: "/restaurant/comments",
            method: "get",
            query: {page},
        })
    })
    return (
        <>
            <Header title="نظرات کاربران"/>
            <div className="flex flex-col w-full p-4 md:p-6 border border-gray-300 rounded-xl">
                <div className="text-xl text-gray-900 border-b border-b-gray-300 pb-4">انتقادات و پیشنهادات</div>
                {!!data?.data?.length ?
                    <div className="flex flex-col gap-8 w-full py-6 md:px-3 ">
                        {isLoading ? <div className="flex items-center justify-center pt-4 w-full"><Spinner/></div> :
                            data?.data?.map((e) => <div key={e.id} className="flex flex-col px-4">
                                <div
                                    className="flex flex-col gap-4 border-b-3 py-4 last:border-none">
                                    <div className="flex flex-col gap-4">
                                        <div className="flex items-start sm:items-center justify-between w-full gap-3 flex-col sm:flex-row">
                                            <div className="flex items-center gap-3">
                                                <CommentAvatar src="/images/iconkarbar.png" alt={e.user_name || ""}/>
                                                <div className="flex flex-col gap-1">
                                                    <span className="font-bold text-sm">{e.user_name}</span>
                                                    <div className="flex">
                                                        <Star rating={e.rate}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <ModalReplay id={e?.id} refetch={refetch} text={e.replies?.[0]?.text}/>
                                        </div>
                                        <div className="flex flex-col gap-4">
                                            <p className="text-gray-600 text-sm whitespace-pre-line">{e.text}</p>
                                            <div className="flex items-center flex-wrap gap-4  sm:text-base text-sm">
                                                {!(e.legacy_hide_food || e.source === 'legacy') && e.order?.map((i, index) => <div key={index}
                                                                                 className="bg-gray-500 text-white rounded px-2 py-1">{i}</div>)}
                                                <Link to={`/orders/${e.order_id}`}
                                                      className=" flex items-center gap-2 bg-[#CBFFA3] border border-[#88E73F] text-white rounded px-2 py-1">
                                                    <p className=" text-[#177E39]">کد سفارش :</p>
                                                    <p className=" text-[#177E39]">{e.order_id}</p>
                                                </Link>
                                            </div>
                                            <div className="self-end">
                                                <div className="flex items-center gap-6">
                                                    <LikeDislike justView refetch={refetch} e={e}/>
                                                    <p className="text-gray-600 text-sm">{e.created}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {!!e.replies?.length && e.replies.map((y) => (
                                        <div className="rest-comment-reply" key={y.id}>
                                            <div className="rest-comment-reply__icon" aria-hidden="true">
                                                <Replay/>
                                            </div>
                                            <div className="rest-comment-reply__body">
                                                <div className="rest-comment-reply__header">
                                                    <CommentAvatar src="/images/ashpazicon.png" alt=""/>
                                                    <span className="rest-comment-reply__label">پاسخ رستوران</span>
                                                </div>
                                                <p className="rest-comment-reply__text">{y.text}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>)}
                    </div> :
                    <p className="lg:text-lg text-gray-700 pt-4 text-center">هنوز هیج نظری ثبت نشده است </p>
                }
            </div>
            <PaginationApp
                currentPage={page}
                pages={data?.last_page}
                onChange={setPage}
            />
        </>
    );
};

export default Comments;
